import React, { useEffect, useState } from "react";
import { TopBar } from "../../components/CommonComponent/Topbar";
import { AvatarFromScratchCard } from "../../components/MyAvatarNew/AvatarFromScratchCard";
import { getData } from "../../components/common/api";
import DataNotAvailable from "../../components/common/DataNotAvailable";
import { useNavigate } from "react-router-dom";
import { message } from "antd";

export const MyAvatar = () => {
  const [avatares, setAvatares] = useState([]);
  const [rerender, setRerender] = useState(false);
  const token = localStorage.getItem('token')
  const navigate=useNavigate();
  useEffect(() => {
    getData(setAvatares);
  }, [rerender]);

  const handleDelete = async (id)=>{
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ROOT}/api/bot/createbot/?BotId=${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          method: "DELETE",
        }
      );

      if (response.status === 200 || response.status === 201) {
        setAvatares(prevAvatares => prevAvatares.filter(avatare => avatare.BotId !== id));
        message.success("Bot has been deleted!");
      } else {
        message.error("Bot could not be deleted!");
      }
    } catch (error) {
      message.error("Error deleting bot");
    }

  }
  return (
    <div>
      <TopBar text="My Avatare" />
      <div className="py-2 px-8">
        
        {avatares?.length > 0 ?<div>
          <h1 className="text-xl font-medium mt-3">
            Created from Scratch
          </h1>
          <div className="mt-3.5 mb-20">
            <div className="flex gap-6 m-w-[50%] flex-wrap">
              {avatares?.map((data, key) => (
                <AvatarFromScratchCard dotsIcon={true} handleDelete={handleDelete} key={key} data={data} />
              ))}
            </div>
          </div>
        </div>: <DataNotAvailable text="Looks like you don’t have any Avatare yet" subText="Let’s create the first one" handleClick={(e)=>navigate("/admin/createAvatar")} buttontext={"Let's create"}  />}
      </div>
    </div>
  );
};
